import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { Typography, Box, Button, Table, TableRow, TableBody, TableCell, TableContainer, Paper, TableHead, TextField, Grid } from "@mui/material";
import "./dotsStyles.css"
import { keyframes } from "@mui/material";
import LoadingDots from "./LoadingDots";
function AI_CHAT(props) {
  const { t } = useTranslation();
  const { client, accessToken, program, ansprung, übergabe } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");

  const [scale, setScale] = useState(0);
  const [isTyping, setIsTyping] = useState(false);

  const navigate = useNavigate();
  let pageHeight = String(window.innerHeight - 150) + "px";
  let chatHeight = String(window.innerHeight - 170) + "px";
const toolDetails={"GEHALT_DETAILS":"Lese Lohnarten aus"}
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client, // this.props.client,
      program: program,
      statement: ansprung,
      funktion: "INIT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, initCb, setRedirect);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log(messages);
    console.log(messages[messages.length - 1]?.tool_calls);
    if (messages && messages.length > 0 && messages[messages.length - 1]?.tool_calls?.length > 0) {
      toolCall(messages[messages.length - 1].tool_calls);
      return;
    }
    if (messages && messages.length > 0 && messages[messages.length - 1].role === "assistant") {
      // toolCall(messages[messages.length - 1].tool_calls);
      setIsTyping(false);
    }
    // setIsTyping(false);
  }, [messages]);

  const initCb = (response) => {
    if (response.status === 200) {
      setIsLoading(false);
    }
  };
  const setRedirect = (path) => {
    // props.showError(null);
    // navigate(path);
  };

  const toolCall = (tool) => {
    const payload = {
      mandant: client, // this.props.client,
      program: program,
      statement: ansprung,
      tool: tool[0]?.function.name,
      arguments: tool[0]?.function.arguments,
      userChoice: tool[0]?.userChoice,
      funktion: "TOOL",
      withTools: true,
      ...übergabe,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest(
      "POST",
      "daten",
      payload,
      headers,
      (response) => {
        if (response.data.error) {
          const toolMessage = {
            role: "tool",
            ok: false,
            content: response.data.error,
            tool_call_id: tool[0].function.id,
            name: tool[0].function.name,
          };
          setMessages((prevState) => [...prevState, toolMessage]);
          return;
        }
        if (response.data.userInput === "J") {
          const toolMessage = {
            role: "choice",
            ok: false,
            content: response.data.userChoices,
            toolMessage: tool,
            tool_call_id: tool[0].function.id,
            name: tool[0].function.name,
          };
          setMessages((prevState) => [...prevState, toolMessage]);
          return;
        }
        const toolMessage = {
          ok: response.data.error ? false : true,
          error: response.data.error ? res.data.error : "",
          role: "tool",
          content: response.data.content,
          tool_call_id: tool[0].function.id,
          name: tool[0].function.name,
        };
        setMessages((prevState) => [...prevState, toolMessage]);
        const slicedMessages = messages.filter((e) => e.role !== "choice").slice(Math.max(messages.length - 5, 0));
        // const slicedMessages = [...messages, toolMessage].slice(Math.max(messages.length - 3, 0));
        slicedMessages.push(toolMessage);

        const payload = {
          mandant: client, // this.props.client,
          program: program,
          statement: ansprung,
          messages: slicedMessages,
          funktion: "MESSAGE",
          withTools: false,
          ...übergabe,
        };
        const headers = {
          Authorization: "Bearer " + accessToken,
        };
        apiRequest("POST", "daten", payload, headers, messageCb, setRedirect);
      },
      setRedirect
    );
  };
  const toolCb = (response) => {};

  const sendMessage = () => {
    const slicedMessages = messages.slice(Math.max(messages.length - 15, 0));
    slicedMessages.push({
      role: "user",
      content: message,
    });

    setMessages((prevState) => [
      ...prevState,
      {
        role: "user",
        content: message,
      },
    ]);
    setMessage("");
    setIsTyping(true);
    // setIsSending(true);

    const payload = {
      mandant: client, // this.props.client,
      program: program,
      statement: ansprung,
      messages: slicedMessages,
      funktion: "MESSAGE",
      withTools: true,
      ...übergabe,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, messageCb, setRedirect);
  };
  const messageCb = (response) => {
    if (response.data.choices && response.data.choices.length > 0) {
      function isJsonString(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          return false;
        }
        return true;
      }
      if (isJsonString(response.data.table)) {
        const table = JSON.parse(response.data.table);

        setMessages((prevState) => [...prevState, { ...response.data.choices[0].message, table }]);
      } else {
        setMessages((prevState) => [...prevState, response.data.choices[0].message]);
      }

      setIsLoading(false);
      // if (response.data.choices[0].message.tool_calls) {
      //   toolCall(response.data.choices[0].message.tool_calls)
      //   }
    }
  };
  const handleKeyDown = (e) => {
    if (!e.altKey) return;
    if (e.key !== "s") return;

    sendMessage();
    e.preventDefault();
  };
  useEffect(() => {
    const intervalId = setInterval(() => {
      setScale((prevScale) => (prevScale === 0 ? 10 : 0));
    }, 1000); // adjust the timing as needed

    return () => clearInterval(intervalId);
  }, [isTyping]);
  const userSelection = (userChoice, message) => {
    const newToolMessage = {
      role: "assistant",
      ok: false,
      tool_calls: [
        {
          userChoice: userChoice, // content: response.data.userChoices,
          function: message.toolMessage[0].function,
          // function: [{ ...message.toolMessage[0].function, arguments: { ...message.toolMessage[0].function.arguments, userChoice:userChoice} }],
          tool_call_id: message.toolMessage[0].function.id,
          name: message.toolMessage[0].function.name,
        },
      ],
    };
    setMessages((prevState) => [...prevState, newToolMessage]);
  };
  const renderTable = (message) => {
    if (message.table) {      
      return (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                {message.table.table.column.map((column, index) => (
                  <TableCell key={index}>{column.key}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {message.table.table.row.map((row, index) => (
                <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                  {message.table.table.column.map((column, columnIndex) => (
                    <TableCell key={columnIndex}>{row[column.key]}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      );
    }
    return null;
  };
  const renderToolDetails=(messages)=>{    
        if (messages[messages.length-1]?.tool_calls?.[0]?.function.name){
      return(
        
           <div style={{display:"flex",height:"48px",marginTop: "20px "}}>
            {/* {toolDetails[messages[messages.length-1]?.tool_calls?.[0]?.function.name].split(" ")?.map((text)=>(<div>{text}</div>))} */}
            {toolDetails[messages[messages.length-1]?.tool_calls?.[0]?.function.name]}
        
      </div>
      )
    }

    // if (messages[messages.length-1]?.tool_calls?.[0]?.function.name){
    //   return(
        
    //        <div className="bouncing_text" style={{display:"flex",height:"48px",marginTop: "20px "}}>
    //         {toolDetails[messages[messages.length-1]?.tool_calls?.[0]?.function.name].split(" ")?.map((text)=>(<div>{text}</div>))}
        
    //   </div>
    //   )
    // }
  }
  if (isLoading) {
    return <LoadingComponent />;
  }
  return (
    <Box style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <Grid container style={{ overflowY: "auto" }}>
        {messages.map((message) => {
          if (message.role === "user") {
            return (
              <Grid item xs={12} style={{ marginBottom: 1, height: "fit-content" }}>
                <div style={{ display: "flex", justifyContent: "flex-end", border: "2px", marginBottom: "4px" }}>
                  <div
                    style={{
                      backgroundColor: "#ADD8E6",
                      padding: 10,
                      borderRadius: 10,
                      maxWidth: "70%",
                      height: "fit-content",
                      border: "2px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <span style={{ fontSize: 16, color: "#333" }}>{message.content}</span>
                  </div>
                </div>
              </Grid>
            );
          } else if (message.role === "assistant" && message.content !== null) {
            return (
              <Grid item xs={12} style={{ marginBottom: 1, height: "fit-content" }}>
                <div style={{ display: "flex", justifyContent: "flex-start", border: "2px" }}>
                  <div
                    style={{
                      backgroundColor: "#F7F7F7",
                      padding: 10,
                      borderRadius: 10,
                      maxWidth: "70%",
                      height: "fit-content",
                      border: "2px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <span style={{ fontSize: 16, color: "#333", whiteSpace: "pre-wrap" }}>{message.content}</span>
                  </div>
                </div>
                {renderTable(message)}
              </Grid>
            );
          } else if (message.role === "choice" && message.content !== null) {
            return (
              <Grid item xs={12} style={{ marginBottom: 1, height: "fit-content" }}>
                {message.content.map((choice) => (
                  <Button onClick={() => userSelection(choice.key, message)}>{choice.bez}</Button>
                ))}
                {/* <div style={{ display: "flex", justifyContent: "flex-start", border: "2px" }}>
                  <div
                    style={{
                      backgroundColor: "#F7F7F7",
                      padding: 10,
                      borderRadius: 10,
                      maxWidth: "70%",
                      height: "fit-content",
                      border: "2px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <span style={{ fontSize: 16, color: "#333" }}>{message.content}</span>
                  </div>
                </div> */}
              </Grid>
            );
          } else if (message.role === "tool" && message.ok === false) {
            return (
              <Grid item xs={12} style={{ marginBottom: 1, height: "fit-content" }}>
                <div style={{ display: "flex", justifyContent: "flex-start", border: "2px" }}>
                  <div
                    style={{
                      backgroundColor: "#F7F7F7",
                      padding: 10,
                      borderRadius: 10,
                      maxWidth: "70%",
                      height: "fit-content",
                      border: "2px",
                      boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <span style={{ fontSize: 16, color: "#333" }}>{message.content}</span>
                  </div>
                </div>
              </Grid>
            );
          }
        })}
        {isTyping && (
          <>
            <Grid item xs={12} style={{ marginBottom: 1, height: "fit-content" }}>
              <LoadingDots />
              {renderToolDetails(messages)}
            </Grid>
          </>
        )}
      </Grid>
      <Grid container style={{ marginTop: "auto" }}>
        <Grid item xs={12}>
          <TextField fullWidth onChange={(e) => setMessage(e.target.value)} onKeyUp={handleKeyDown} value={message}></TextField>
          <Button onClick={() => sendMessage()}>Senden</Button>
        </Grid>
      </Grid>
    </Box>
  );
}
export default AI_CHAT;
